///	<reference types="./typings.d.ts" />

import {isDevMode as angularIsDevMode} from '@angular/core';

import {environment} from '../environments';

export function isTypeOf<T>(value: any, type: T): value is T {
	if (typeof type === 'object') {
		return Object.values(type).includes(value);
	}
	return typeof value === type;
}

globalThis.isTypeOf = isTypeOf;

/* -------------------------------------------------------------------------------------------------------------- */
export function isDevMode(): boolean {
	return typeof environment?.DEV_MODE === 'boolean' ? environment.DEV_MODE : angularIsDevMode();
}

globalThis.isDevMode = isDevMode;
/* -------------------------------------------------------------------------------------------------------------- */
export const EnvironmentName = {
	Dev: 'dev',
	Xyz: 'xyz',
	Biz: 'biz',
	Net: 'net',
} as const;
export type EnvironmentNameBase = (typeof EnvironmentName)[keyof typeof EnvironmentName];
export type EnvironmentName = (typeof EnvironmentName)[keyof typeof EnvironmentName] | `${(typeof EnvironmentName)[keyof typeof EnvironmentName]}-local`;

/* -------------------------------------------------------------------------------------------------------------- */
/**
 * @description URL structure for the DocCycle application
 * @param {string} tenant - The tenant name
 * @param {EnvironmentName} environment - The environment name
 * @param {Record<string, string>} route_params - The route parameters
 * @param {string} apiUrl - The API URL
 */
export type DcUrlStructure = {
	tenant?: string;
	environment: EnvironmentName;
	params?: Record<string, string>;
	apiUrl?: ApiUrl;
};

/* -------------------------------------------------------------------------------------------------------------- */
declare function enumType<Type extends object>(obj: Type): ValueOf<Type>;

/* ------------------------------------ . ----------------------------------- */
globalThis.tryCatchFn = function tryCatchFn<T>(
	fn: () => T,
	opts?: {
		errorLog?: string;
		catchError?: (error: any) => any;
	},
): T | never {
	try {
		return fn();
	} catch (error) {
		if (opts?.errorLog) {
			console.error(opts.errorLog, error);
		}
		if (opts?.catchError) {
			return opts.catchError(error);
		}
		throw error;
	}
};
/* -------------------------------------------------------------------------------------------------------------- */
export const withLoadState: WithLoadState = {
	loading: false,
	loaded: false,
} as const;

export const withErrorState: WithErrorState = {
	error: null,
} as const;

export const withId: WithId = {
	id: '',
} as const;
/* -------------------------------------------------------------------------------------------------------------- */
export type SelectOption<T = any> = {
	value: T;
	label: string;
	items?: SelectOption<T>[]; // only for grouped options
};

export {};
